var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen"},[(!_vm.isFullScreen)?_c('i',{staticClass:"fal fa-expand-arrows fullscreen__icon",on:{"click":function($event){return _vm.setFullscreen(true)}}}):_c('i',{staticClass:"fal fa-compress-alt fullscreen__icon",on:{"click":function($event){return _vm.setFullscreen(false)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }